/**
 * The story's two reads:
 *
 * - `GET /me/retrospective` (contracts §7, T34) with no `week`, so the key is
 *   `"latest"` and the server's clock picks last week, never the device's;
 * - `GET /me/progress?weeks=8` (§6, T33) for the bars and the grid, under the
 *   SAME key the Progress screen uses, so opening the story from Progress
 *   reads the cache instead of the network.
 *
 * Both in the catalogue locale, so muscle and exercise names arrive
 * translated and are never translated again here.
 */

import {
  progressOptions,
  retrospectiveOptions,
} from "@repo/client/data/progress";
import { PROGRESS_DEFAULT_WEEKS } from "@repo/contract/training";
import { useApi } from "../../data/api";
import { useDataQuery } from "../../data/query-client";
import { catalogueLocale } from "../../lib/locale";
import type { StoryPeriod } from "./model";

/**
 * The story's cards. `period` absent or `"week"` is the request as it always
 * was; a month or a year (`D204`) is keyed apart, under the same prefix, and
 * is the same key Progress's entries read.
 */
export function useRetrospective(period?: StoryPeriod) {
  const api = useApi();
  return useDataQuery(
    retrospectiveOptions(api, {
      locale: catalogueLocale(),
      ...(period === undefined || period === "week" ? {} : { period }),
    })
  );
}

export function useProgressWindow() {
  const api = useApi();
  return useDataQuery(
    progressOptions(api, {
      locale: catalogueLocale(),
      weeks: PROGRESS_DEFAULT_WEEKS,
    })
  );
}
